import  * as React from 'react'
// Translation
import {useI18next} from 'gatsby-plugin-react-i18next'
import { graphql } from 'gatsby';
//components
import Layout from '../../components/layout/layout'
import { Seo } from '../../components/seo';
//const: muss definiert werden unter "export default"
const RecyklateProdukte  = () => {
    const {t} = useI18next();
    return (
        <Layout pageTitle={t('title')} subTitle={t('subtitle')}>
          {/* Block mit weissem hintergrund 
          <div className='row'>

            <div className='col-12'>
              <div className='container'>
                <BoxInfo description={t('text')} />
              </div>
            </div>
          </div>
        */}
          <div className='row'>
            {/* 1 oder mehr Blöcke am Anfang: Titel und Text / ggf später ein Bild */}
            <div className='col-12'>
              <div className='container'>
                <h2 align="left"> {t('title1')} </h2>
                <p> {t('text11')} </p>
                <p> {t('text12')} </p>
                <p> {t('text13')} </p>

                <h2 align="left"> {t('title2')} </h2>
                <h3 align="left"> {t('subtitle21')} </h3>
                <p> {t('text211')} </p>
                <p> {t('text212')} </p>
                <h3 align="left"> {t('subtitle22')} </h3>
                <p> {t('text221')} </p>
                <p> {t('text222')} </p>

                <h2 align="left"> {t('title3')} </h2>
                <p> {t('text311')} </p>

                <h2 align="left"> {t('title4')} </h2>
                <p> {t('text411')} </p>


            
                {/*<p>{t('bildtext1')}</p>              : ggf ein Bild einfügen / passt hier aber nicht
                <StaticImage alt="ein bil d" src="../images/CAD-Zeichnungen-RK.jpg"/> */}
              </div>
            </div>
          </div>
        </Layout>

    );
};

export default RecyklateProdukte

// Fuer Search engine  optimizationjj
export const Head = () =>( <Seo title="Produktentwicklung" keywords="Produktentwicklung Biopolymere" /> )

// Für Mehrsprachigkeit, graphql muss am anfang import werden!
export const query = graphql`
query ($language: String!) {
  locales: allLocale(
    filter: { ns: { in: ["rezyklateprodukte"] }, language: { eq: $language } }
  ) {
    edges {
      node {
        ns
        data
        language
      }
    }
  }
}
`;